export function formatRelativeTimeKorean(dateString: string) {
  const pastTime = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - pastTime.getTime();
  const diffSec = diffMs / 1000;
  const diffMin = diffSec / 60;
  const diffHour = diffMin / 60;
  const diffDay = diffHour / 24;

  if (diffSec < 120) {
    return '방금전';
  } else if (diffMin < 60) {
    return `${Math.floor(diffMin)}분전`;
  } else if (diffHour < 24) {
    return `${Math.floor(diffHour)}시간전`;
  } else if (diffDay < 7) {
    return `${Math.floor(diffDay)}일전`;
  } else if (diffDay < 14) {
    return '일주일전';
  } else if (diffDay < 30) {
    return '이주전';
  } else {
    return '한달전';
  }
}
